import * as fragment from "./cms";
import * as resource from "./resource";

export const examConfigFragment = `
${resource.id}
${resource.basic}
author
subject
grade
language
editorId
creatorId
questionIds
contextIds
alignmentIds
isUserFavorite
isUserWatcher
alignments {
  items {
    id
    scope
    abbreviation
  }
}
resource {
  id
  sk
  idInc
  name
  description
  ${resource.tags}
}
${resource.tags}
`;

export const examContent = `
  content {
    forms {
      sections {
        name
        questionIds
      }
    }
  }
`;

export const examQuestions = `
  questions {
    id
    sk
    workspaceId
    bankId
    idInc
    name
    fontScaling
    idVendor
    maturity
    subject
    language
    creatorId
    ${resource.tags}
    ${resource.alignmentsAbbrs}
    content {
      canvas {
        id
        type
        interactionType
        content
        config
        scoring
      }
    }
    contexts {
      items {
        id
        sk
        name
        type
        content {
          body
        }
      }
    }
  }
`;

export const examEditorItemFields = `
  ${fragment.base}
  type
  name
  maturity
  fontScaling
  language
  scoringMethod
  alignments {
    items {
      ${fragment.objective}
    }
    nextToken
  }
  contexts {
    items {
      ${fragment.context}
    }
    nextToken
  }
  content {
    canvas {
      ${fragment.canvas}
    }
  }
  workspaceId
`;

export const getExamOrConfigForLaunch = `
id
idInc
name
examSessionResponses
creator {
  id
  firstName
  lastName
  email
}
config
resource {
  id
  idInc
  name
  questionIds
  content {
    forms {
      sections {
        name
        questionIds
      }
    }
  }
  questions {
    id
    sk
    name
    content {
      canvas {
        id
        type
        interactionType
        content
        config
      }
    }
    contexts {
      items {
        id
        sk
        name
        type
        content {
          body
        }
      }
    }
  }
}
`;

export const searchExamsDetails = `
items {
  id
  sk
  idInc
  createdAt
  updatedAt
  maturity
  name
}
total
nextToken
`;

export const searchExamSessions = `
items {
  id
  idInc
  idVendor
  sk
  type
  version
  bankId
  name
  maturity
  schemaVersion
  createdAt
  updatedAt
  workspaceId
  examSessionResults
  imageUrl
  imageHash
}
nextToken
`;

export const searchExamResponses = `
id
sk
name
idInc
createdAt
updatedAt
scoreActual
scoreMax
resourceId
examSessionResponses
tags {
  key
  type
  value
}
`;

export const getExamSession = `id
sk
idInc
name
maturity
examSessionData {
  studentId
  lti {
    product
  }
}
examSessionResponses
examSessionResults
examConfigId
workspaceId
createdAt
updatedAt
`;

export const getExamConfig = `
id
sk
idInc
name
workspaceId
alignments {
  items {
    id
    sk
    content
    abbreviation
    scope
  }
}
resource {
  id
  sk
  name
  createdAt
  updatedAt
  questions {
    id
    sk
    name
    idInc
    content {
      canvas {
        content
        scoring
        config
      }
    }
  }
  content {
    forms {
      sections {
        questionIds
      }
    }
  }
}
`;
